import { render, staticRenderFns } from "./PatientFlow.vue?vue&type=template&id=a108cef8&scoped=true"
import script from "./PatientFlow.vue?vue&type=script&lang=js"
export * from "./PatientFlow.vue?vue&type=script&lang=js"
import style0 from "./PatientFlow.vue?vue&type=style&index=0&id=a108cef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a108cef8",
  null
  
)

export default component.exports